import { useMediaQuery } from "beautiful-react-hooks";
import { useState } from "react";
import Header from "./components/Header";
import Chat from "./components/chat/Chat";
import ChatForm from "./components/chat/ChatForm";
import Game from "./components/game/Game";
import SidebarFixed from "./components/sidebar/SidebarFixed";
import SidebarSliding from "./components/sidebar/SidebarSliding";

const App = ({ user, room }) => {
  const sidebarLeft = false;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);

  const isLarge = useMediaQuery("(min-width: 1024px)");

  return (
    <div className="font-sans leading-normal tracking-normal">
      <Header user={user} setSidebarOpen={setSidebarOpen} />
      <div className="flex lg:h-[calc(100dvh-4rem)] h-[calc(100dvh-3rem)]">
        <div
          className={`h-full flex flex-col w-0 flex-1 ${
            sidebarLeft ? "order-1" : ""
          }`}
        >
          <div className="h-full flex flex-col flex-nowrap">
            <Game room={room} />
            <Chat inputFocused={inputFocused} />
            <ChatForm setFocus={setInputFocused} cooldown={room.cooldown} />
          </div>
        </div>
        {isLarge && (
          <SidebarFixed
            user={user}
            room={room}
            position={sidebarLeft ? "left" : "right"}
          />
        )}
        {!isLarge && (
          <SidebarSliding
            user={user}
            room={room}
            open={sidebarOpen}
            setOpen={setSidebarOpen}
          />
        )}
      </div>
    </div>
  );
};
export default App;
